import { CommonModule } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Labels } from '@core/constants/labels';
import { ReportingService } from '@core/services/reporting-service/reporting-service.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-error-report-dialog',
  templateUrl: './error-report-dialog.component.html',
  styleUrls: ['./error-report-dialog.component.scss'],
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    CommonModule,
  ],
})
export class ErrorReportDialogComponent implements OnDestroy {
  errorReportForm: FormGroup;
  private subscription: Subscription = new Subscription();
  textareaInteracted = false;

  labels = Labels.BUG_REPORT;

  constructor(
    private dialogRef: MatDialogRef<ErrorReportDialogComponent>,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private reportingService: ReportingService,
  ) {
    this.errorReportForm = this.fb.group({
      error_message: ['', []],
    });
  }

  errorLocation: string | null = null;
  subOption: string | null = null;
  subOption2: string | null = null;

  selectErrorLocation(location: string) {
    this.errorLocation = location;
    this.subOption = null;
    this.subOption2 = null;
    this.resetErrorMessageValidation();
  }

  selectSubOption(option: string) {
    this.subOption = option;
    this.subOption2 = null;
    this.resetErrorMessageValidation();
  }

  selectSubOption2(option: string) {
    this.subOption2 = option;
    this.resetErrorMessageValidation();
  }

  private resetErrorMessageValidation() {
    const errorMessageControl = this.errorReportForm.get('error_message');
    errorMessageControl?.setValidators([]);
    errorMessageControl?.updateValueAndValidity();
    this.textareaInteracted = false;
  }

  onTextareaInteraction() {
    if (!this.textareaInteracted) {
      const errorMessageControl = this.errorReportForm.get('error_message');
      errorMessageControl?.setValidators([
        Validators.required,
        Validators.minLength(1),
      ]);
      errorMessageControl?.updateValueAndValidity();
      this.textareaInteracted = true;
    }
  }

  onSubmit() {
    this.onTextareaInteraction(); // Ensure validation is applied before submission
    if (this.errorReportForm.valid && this.errorLocation) {
      const formData = {
        error_message: this.errorReportForm.value.error_message,
        error_metadata: {
          error_location: this.errorLocation,
          sub_option: this.subOption,
          sub_option2: this.subOption2,
        },
      };
      const sub = this.reportingService
        .reportError(formData.error_message, formData.error_metadata)
        .subscribe({
          next: () => {
            this.toastr.success(this.labels.SUCCESS);
            this.dialogRef.close();
          },
          error: (error) => {
            this.toastr.error(this.labels.ERROR);
          },
        });
      this.subscription.add(sub);
    }
  }

  onCancel() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
